/**
 * O parâmetro `jobId` da URL, que o link da notificação de relatório pronto usa para abrir
 * Relatórios Solicitados (/admin/manage/reportjobs) no pedido certo. Em /fleet e /client o sino manda o
 * jobId no estado da navegação, não na query, que lá é do relatório aberto no mapa.
 */

const pairsOf = (search) => search.replace(/^\?/, '').split('&').filter(Boolean);
const isJobId = (pair) => pair.split('=')[0] === 'jobId';

/**
 * @param {string} search `location.search`
 * @return {number|null} o jobId, ou `null` se faltar ou não for um inteiro sem sinal
 */
export const readJobId = (search) => {
  const pair = pairsOf(search).find(isJobId);
  const value = pair === undefined ? '' : pair.slice('jobId='.length);
  if (!/^\d+$/.test(value)) {
    return null;
  }
  const jobId = Number(value);
  return Number.isSafeInteger(jobId) ? jobId : null;
};
